export const tutorialsCN = {
    'Tutorials.Simon.AI': 'Simon AI',
    'Tutorials.Homepage.Overview': '主页介绍',
    'Tutorials.Upload.Matrix': '上传矩阵',
    'Tutorials.Initiate.Analysis': '启动分析',
    'Tutorials.See.More.Details': '点击查看更多说明',
    'Tutorials.Got.It': '好的！',
    'Tutorials.Show.Again': '不再提示',
    'Tutorials.Step3.Title': '如何上传单样本矩阵?',
    'Tutorials.Step4.Title': '如何启动本地数据整合分析？',
    'Tutorials.Step1.btn1': '立即体验',
    'Tutorials.Step1.btn2': '跳过',
    'Tutorials.Step1.btn3': '快速入门',
    'Tutorials.Step5.AskSimon': 'Ask Simon',
    'Tutorials.Step5.Nav.Title': 'Simon AI',
    'Tutorials.Step5.Nav.Desc': '点击顶部导航栏的Simon AI，可自由选择解读/绘图/分析三种模式',
    'Tutorials.Step5.Run.Title': 'Run旁Ask Simon',
    'Tutorials.Step5.Run.Prefix': '在分析任务页面点击',
    'Tutorials.Step5.Run.Suffix': '，AI帮您提交新的云端分析任务。',
    'Tutorials.Step5.Results.Title': '结果旁 Ask Simon',
    'Tutorials.Step5.Results.Prefix': '在分析结果页面点击',
    'Tutorials.Step5.Results.Suffix': '，AI帮您解读指定分析结果的生物学意义。',
    'Tutorials.Step5.Tools.Title': '工具旁 Ask Simon',
    'Tutorials.Step5.Tools.Prefix': '在工具页面内点击',
    'Tutorials.Step5.Tools.Suffix': '，AI帮您定制指定可视化图表。',

};


export const tutorialsUS = {
    'Tutorials.Simon.AI': 'Simon AI',
    'Tutorials.Homepage.Overview': 'Homepage Overview',
    'Tutorials.Upload.Matrix': 'Upload matrix',
    'Tutorials.Initiate.Analysis': 'Initiate analysis',
    'Tutorials.See.More.Details': 'Click to see more details',
    'Tutorials.Got.It': 'Got it !',
    'Tutorials.Show.Again': "Don't show this again",
    'Tutorials.Step3.Title': 'How to upload Single-Sample Matrix?',
    'Tutorials.Step4.Title': 'How to start local data integration analysis?',
    'Tutorials.Step1.btn1': 'Get Started',
    'Tutorials.Step1.btn2': 'Skip',
    'Tutorials.Step1.btn3': 'Quick Start',
    'Tutorials.Step5.AskSimon': 'Ask Simon',
    'Tutorials.Step5.Nav.Title': 'Simon AI',
    'Tutorials.Step5.Nav.Desc': 'Simon AI in nav bar, freely choose Interpret / Plot / Analyze modes',
    'Tutorials.Step5.Run.Title': 'Ask Simon next to Run',
    'Tutorials.Step5.Run.Prefix': 'Click',
    'Tutorials.Step5.Run.Suffix': 'on analysis page, AI helps submit new cloud analysis.',
    'Tutorials.Step5.Results.Title': 'Ask Simon on results',
    'Tutorials.Step5.Results.Prefix': 'Click',
    'Tutorials.Step5.Results.Suffix': 'on results page, AI helps interpret your results and more.',
    'Tutorials.Step5.Tools.Title': 'Ask Simon in Tools',
    'Tutorials.Step5.Tools.Prefix': 'Click',
    'Tutorials.Step5.Tools.Suffix': 'within any tool page, AI helps plot custom visualizations.',

};